import { Typography, Button } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

interface ConfirmDiscardPlanDialogProps {
  onCancel: () => void;
  onContinueLater: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}
export const ConfirmDiscardPlanDialog = ({
  onCancel,
  onContinueLater,
  onConfirm,
  isLoading,
}: ConfirmDiscardPlanDialogProps) => {
  return (
    <BaseDialog
      actionsComponent={
        <>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button variant="outlined" onClick={onContinueLater}>
            Continuar depois
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            loading={isLoading}
            color="error"
          >
            Descartar plano
          </Button>
        </>
      }
      onClose={onCancel}
      title="Tem certeza de que deseja sair?"
      icon={<Icon name="siren-rounded" />}
    >
      <Typography gutterBottom>
        Você ainda não concluiu a criação do seu plano. Se sair, perderá o que
        fez até agora.
      </Typography>
    </BaseDialog>
  );
};
